import { Button, Collapse, Form, notification, Spin, Tooltip } from "antd";
import { FormComponentProps } from "antd/lib/form";
import DataGrid, { Column, FilterRow, Grouping, GroupPanel, HeaderFilter, Pager, Paging, Selection } from "devextreme-react/data-grid";
import * as React from "react";
import { useContext, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { useEffect } from "src/ReactTS";
import { IPrecatorio } from "src/services/interfaces/IPrecatorio";
import { ServiceContext } from "src/services/provider/Service.provider";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { MonitorPrecatoriosQuote } from "./MonitorPrecatoriosQuote";
import "./consult.scss";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";
import { FoundPrecatorioStatusEnum } from "src/services/Enum/dap/FoundPrecatorioStatusEnum";
import { IPrecatorioDapResponse } from "src/services/interfaces/IPrecatorioDapResponse";

function MonitorPrecatoriosList(props: { max?: number } & RouteComponentProps<any> & FormComponentProps) {
  const { precatorioService, tradeService, quoteService } = useContext(ServiceContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [precatorio, setPrecatorio] = useState<IPrecatorio>(null);
  const [activePanel, setActivePanel] = useState("1");
  const [quote, setQuote] = useState<IQuote>(null);
  const moneyMask = (params: any) => MoneyMask(params.value!);
  useEffect(() => {
    fetch();
  }, []);

  async function fetch(params = {}) {
    setLoading(true);

    try {
      let precatorios = await precatorioService.getAll();
      if (props.max) {
        precatorios = precatorios.slice(0, props.max);
      }
      setData(precatorios);
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Falha na consulta",
        description: "Ocorreu um erro durante a consulta. Tente novamente."
      });
    } finally {
      setLoading(false);
    }
  }

  function acceptQuote() {
    tradeService
      .postCreateFromQuote(quote)
      .then(result => {
        props.history.push(`/venda/${result.id}`, {
          trade: result
        });
      })
      .catch(error => {
        console.log(error);
        notification.error({
          message: "Erro durante o processo de venda.",
          description: "Não foi possível prosseguir com o processo de venda. Por favor tente novamente, ou entre em contato conosco."
        });
      });
  }

  function showQuote(p: IPrecatorioDapResponse) {
    setLoading(true);
    setPrecatorio(p);
    quoteService
      .postShowQuoteFromPrecatorio(p)
      .then(result => {
        setQuote(result);
        setActivePanel("2");
      })
      .catch(error => {
        console.log(error);
        notification.error({
          message: "Erro ao realizar a cotação",
          description: "Não foi possível realizar a cotação"
        });
      })
      .finally(() => setLoading(false));
  }

  return (
    <Spin spinning={loading}>
      <PbrCard className="consult" title="Consulte precatórios" bordered={false} style={{ width: "100%" }}>
        <Collapse bordered={false} destroyInactivePanel activeKey={activePanel}>
          <Collapse.Panel style={{ border: "none" }} header="" key="1" showArrow={false}>
            <div className="consult-results">
              <DataGrid
                dataSource={data}
                allowColumnReordering
                showBorders
                loadPanel={{ enabled: loading }}
                rowAlternationEnabled
                hoverStateEnabled
                columnAutoWidth
              >
                <GroupPanel visible />
                <Grouping autoExpandAll />
                <Selection mode={"multiple"} selectAllMode showCheckBoxesMode />
                <FilterRow visible />
                <HeaderFilter visible />
                <Column
                  caption="#"
                  alignment={"center"}
                  width={"100px"}
                  cellRender={params => {
                    return (
                      <Tooltip title={params.data.message === null ? "Calcular Precatório" : params.data.message}>
                        {params.data.foundPrecatorioStatus !== FoundPrecatorioStatusEnum.FOUND_VALID_PRECATORIO ? (
                          <Button icon="calculator" disabled={true} />
                        ) : (
                          <Button
                            icon="calculator"
                            style={{ color: "white", backgroundColor: "#00C972" }}
                            disabled={false}
                            onClick={() => showQuote(params.data)}
                          />
                        )}
                      </Tooltip>
                    );
                  }}
                />

                <Column caption="#" alignment={"center"} dataField="urlProcess" dataType="string" width={"auto"} cellRender={params => {
                  return (
                    <>
                      <a href={params.data.urlProcess} target={"_blank"}>
                        {" "}
                        {params.data.urlProcess === null ? (
                          <Button icon="link" disabled />
                        ) : (
                          <Tooltip title="Ir ao Site do Tribunal">
                            <Button icon="link" />{" "}
                          </Tooltip>
                        )}
                      </a>
                    </>
                  );
                }}
                />

                <Column caption="#" alignment={"center"} dataField="urlProcessFile" dataType="string" width={"auto"} cellRender={params => {
                  return (
                    <>
                      <a href={params.data.urlProcessFile} target={"_blank"}>
                        {" "}
                        {params.data.urlProcessFile === null ? (
                          <Button icon="file-pdf" disabled />
                        ) : (
                          <Tooltip title="Baixar PDF">
                            <Button icon="file-pdf" />{" "}
                          </Tooltip>
                        )}
                      </a>
                    </>
                  );
                }}
                />
                <Column caption="ID" alignment={"center"} dataField="id" dataType="number" />
                <Column caption="Usuário" alignment={"center"} dataField="user.fullName" dataType="string" />
                <Column caption="Tipo" alignment={"center"} dataField="type.name" dataType="string" />
                <Column caption="Tribunal" alignment={"center"} dataField="court.name" dataType="string" />
                <Column caption="Processo" alignment={"center"} dataField="processCode" dataType="string" />
                <Column caption="Requerente" alignment={"center"} dataField="requester" dataType="string" />
                <Column caption="CPF/CNPJ" alignment={"center"} dataField="cpfCnpj" dataType="string" />
                <Column caption="Data Base" alignment={"center"} dataField="baseDate" dataType="date" format={"dd/MM/yyyy"} />
                <Column caption="Data Expedição" alignment={"center"} dataField="issueDate" dataType="date" format={"dd/MM/yyyy"} />
                <Column caption="Principal" alignment={"center"} dataField="principal" dataType="number" cellRender={moneyMask} />
                <Column caption="Juros" alignment={"center"} dataField="interest" dataType="number" cellRender={moneyMask} />
                <Column caption="Pss" dataField="isPss" dataType="boolean" alignment="center" />
                <Column caption="Ativo" dataField="active" dataType="boolean" alignment="center" />
                <Pager allowedPageSizes={[5, 10, 25, 50, 100]} showPageSizeSelector />
                <Paging defaultPageSize={10} />
              </DataGrid>
            </div>
          </Collapse.Panel>
          <Collapse.Panel className="quote" style={{ border: "none", maxWidth: "800px", marginLeft: "auto", marginRight: "auto" }} header="" key="2" showArrow={false}          >
            <MonitorPrecatoriosQuote precatorio={precatorio} quote={quote} onReject={() => setActivePanel("1")} onAccept={acceptQuote} />
          </Collapse.Panel>
        </Collapse>
      </PbrCard>
    </Spin>
  );
}

export default withRouter(Form.create()(MonitorPrecatoriosList));



// WEBPACK FOOTER //
// ./src/pages/gerencial/precatorios/MonitorPrecatoriosList.tsx